import React, { useEffect } from 'react';
import { useContext } from 'react';
import AuthContext from '../context/auth-context'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Logout() {

  localStorage.removeItem("proxyAuthToken");
  localStorage.removeItem("wpAuthToken");
  localStorage.removeItem("wpAuthRefreshToken");
  localStorage.removeItem("username");

  const authCtx = useContext(AuthContext);
 
  useEffect(() => {
    authCtx.refreshIsLogged();
  }, [authCtx]);

  return (
    <main style={{ padding: "1rem 0", overflow: "auto" }}>

      <div className="container-fluid" style={{ float: "left", minHeight: "46px" }}>

        <h2 style={{ textAlign: "center", margin: "30px" }}>Sei uscito!</h2>

        <div className="row">
          <div className="col-12" style={{ textAlign: "center" }}>
            <Link to="/login">
              <button type="button" className="btn btn-primary" style={{ width: "12rem" }}>
                <FontAwesomeIcon icon={['fas', 'user']} size={'2x'} color={'white'} />
                <span style={{ margin: "8px", verticalAlign: "super" }}>Vai a Login</span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </main>
  )
}